import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStorage } from '../../utils/storage';

export type CurrentLocale = 'en';
type LocaleState = { locale: CurrentLocale };
const initialState: LocaleState = AppStorage.getItem('locale', {
  locale: 'en',
  campagne: null
});

export const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setCurrentLocale: (state, action: PayloadAction<CurrentLocale>) => {
      state.locale = action.payload;
      AppStorage.setItem('locale', state);
      return state;
    }
  }
});

export const { setCurrentLocale } = localeSlice.actions;

export default localeSlice.reducer;
